import { render } from "./ArticlesItem.vue?vue&type=template&id=9cfe6088"
import script from "./ArticlesItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticlesItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/ArticlesItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9cfe6088"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9cfe6088', __exports__)) {
    api.reload('9cfe6088', __exports__)
  }
  
  module.hot.accept("./ArticlesItem.vue?vue&type=template&id=9cfe6088", () => {
    api.rerender('9cfe6088', render)
  })

}


export default __exports__